module.exports = __webpack_public_path__ + "img/photo-01.eab1a6a0.png";